/* eslint-disable max-lines-per-function */
/**
 * @file Contact 组件
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useContext} from 'react';
import {Row, Col, Divider} from 'antd';
import BaseCard from '~/component/BaseCard';
import {BasicLayoutContext} from '~/layout/BasicLayout';

import './index.less';

function Contact() {
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    function handleClick() {}

    return (
        <div className="contact-container">
            <BaseCard title="Contact IR" onClick={handleClick} isConfig={false}>
                <div className="contact-item">
                    <div className="company">
                        Gaotu Techedu Inc.
                    </div>
                    <div className="company-name">
                        Investor Relations
                    </div>
                    <div className="email">
                        <a
                            href="mailto:ir@gaotu.cn"
                        >
                            ir@gaotu.cn
                        </a>
                    </div>
                </div>
                <Row>
                    <Col span={12}>
                        <div className="christensen">
                            Piacente Financial Communications
                        </div>
                        <div className="company-name">
                            Brandi Piacente
                        </div>
                        <div className="company-email">
                            {/* <div className="company-country">
                                In China
                            </div>
                            <Divider type="vertical" /> */}
                            <div className="company-phone">
                                +1 212 481-2050
                            </div>
                            <Divider type="vertical" />
                            <a
                                href="mailto:Gaotu@tpg-ir.com"
                                className="company-email-link"
                            >
                                Gaotu@tpg-ir.com
                            </a>
                        </div>
                    </Col>
                    {
                        !isMobile && (
                            <Col className="company-people">
                                <div className="company-name">
                                    Jenny Cai
                                </div>
                                <div className="company-email">
                                    {/* <div className="company-country">
                                        In the US
                                    </div> */}
                                    {/* <Divider type="vertical" /> */}
                                    <div className="company-phone">
                                        +86 10 6508-0677
                                    </div>
                                    <Divider type="vertical" />
                                    <a
                                        href="mailto:Gaotu@tpg-ir.com"
                                        className="company-email-link"
                                    >
                                        Gaotu@tpg-ir.com
                                    </a>
                                </div>
                            </Col>
                        )
                    }
                </Row>
                {
                    isMobile && (
                        <Row>
                            <Col className="company-people-m">
                                <div className="company-name">
                                    Jenny Cai
                                </div>
                                <div className="company-email">
                                    {/* <div className="company-country">
                                        In the US
                                    </div>
                                    <Divider type="vertical" /> */}
                                    <div className="company-phone">
                                        +86 10 6508-0677
                                    </div>
                                    <Divider type="vertical" />
                                    <a
                                        href="mailto:Gaotu@tpg-ir.com"
                                        className="company-email-link"
                                    >
                                        Gaotu@tpg-ir.com
                                    </a>
                                </div>
                            </Col>
                        </Row>
                    )
                }
            </BaseCard>
        </div>
    );
}

export default Contact;
